import React, { type FC } from 'react'

import { type CybusDeviatedService, selectDeviatedServicesPage, Translation } from '../../../domain'

import { DetailsHeader } from '../common'
import { RedirectingResourcesTable } from '../Resources'
import { RelativeRoutePathWithId } from '../routing'

export const DeviatedServices: FC = () => (
    <>
        <DetailsHeader
            title={Translation.DEVIATED_SERVICES}
            description={[Translation.DEVIATED_SERVICES_DOCUMENTATION_TITLE, Translation.DEVIATED_SERVICES_DOCUMENTATION_BODY]}
        />
        <RedirectingResourcesTable<'manageDeviatedServicesUsecase', CybusDeviatedService, CybusDeviatedService>
            subscriptionUsecase="manageDeviatedServicesUsecase"
            data={selectDeviatedServicesPage}
            dataTableMapper={(r) => r}
            columns={{
                id: { label: Translation.SERVICE_ID, sort: true },
                name: { label: Translation.NAME },
                version: { label: Translation.VERSION },
                resourceDeviationsCount: { label: Translation.DEVIATED_RESOURCES, type: 'number' },
            }}
            redirectOnRowclick={RelativeRoutePathWithId.SERVICE}
            translations={{ emptyTable: Translation.NO_DEVIATED_SERVICES_AVAILABLE, paginationDataType: 'SERVICE' }}
        />
    </>
)
